import React, { useState } from 'react';
import verifyToken from '../HelperFx/verifyJwt.js';
import Nav from './Nav';
import { Alert } from '@mui/material';
import MuiForms from "mui-forms";

const REACT_EXPRESS = process.env.REACT_APP_EXPRESS_SERVER;

const schema = {
  fields: [
    {
      name: "header2",
      meta: {
        displayName: "Inquiry Center",
        displayType: "header"
      }
    },
    {
      name: "title",
      meta: {
        displayName: "Subject",
        displayType: "text_field",
        validation: {
          max: 30,
          required: true
        }
      }
    },
    {
      name: "responseMethod",
      meta: {
        displayType: "select",
        displayName: "How would you want to get a response?",
        options: [
          {
            label: "Email",
            value: "Email"
          }
        ],
        displayProps: {
          md: 6
        }
      }
    },
    {
      name: "question",
      meta: {
        displayName: "Inquiry/Query",
        displayType: "multitext",
        validation: {
          required: true,
          max: 300
        }
      }
    }
  ]
};

const FAQ = () => {
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [formKey, setFormKey] = useState(0); // State to force form reset

  const jwttoken = sessionStorage.getItem('authToken');
  const { custName, userName, userType, password } = verifyToken(jwttoken);

  const handleSubmit = async (formData) => {
    //Console.log(formData);
    setError('');
    setSuccess('');

    if (!formData.question.trim()) {
      setError('Question is required');
      return;
    }

    try {
      const response = await fetch(`${REACT_EXPRESS}/faq`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ qtn: formData.question, userID: userName, title: formData.title })
      });

      const isJson = String(response.headers.get('content-type')).includes('application/json');
      const data = isJson ? await response.json() : {};
      if (!response.ok) {
        throw new Error(data.error || `Failed to submit question (server returned ${response.status})`);
      }

      setSuccess('FAQ submitted successfully!');
      setFormKey(prevKey => prevKey + 1); // Increment key to reset the form
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="Home">
      <Nav />
      <div className="dash-main">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', background: 'white', height: 'fit-content' }}>
          <MuiForms
            key={formKey} // Key prop to force re-render and reset the form
            config={{
              variant: "outlined",
              size: "small"
            }}
            schema={schema}
            onSubmit={(data) => {
              //Console.log("Submitted Data:", data);
              handleSubmit(data);
            }}
          />
          {error && <Alert severity="error" style={{ marginTop: '16px' }}>{error}</Alert>}
          {success && <Alert severity="success" style={{ marginTop: '16px' }}>{success}</Alert>}
        </div>
      </div>
    </div>
  );
};

export default FAQ;